var Wcag = {
	node :null,
	isActive: false,
	textVisible: false,
	couting: null,

	init: function() {
		var docurl = "#";
		if (window.PROJECT.settings['accessibility/docurl'] != undefined && window.PROJECT.settings['accessibility/docurl'] != "") docurl = window.PROJECT.settings['accessibility/docurl'];
		Wcag.node = $(TPL.render("wcag-main", {"docurl": docurl, "showdoc": (docurl != "#" ? true : false)}));

		var trt = 0;

		var hideblind = false;
		var hidewcag = false;

		if (window.PROJECT.settings['accessibility/blindoff'] == "1" || player.offline) {
			Wcag.node.find(".blind-btn").hide();
			hideblind = true;
			trt += 60;
		}

		if (window.PROJECT.settings['accessibility/wcagoff'] == "1") {
			Wcag.node.find(".wcag-btn").hide();
			Wcag.node.find(".blind-btn").css("right", "10px");
			trt += 60;
			hidewcag = true;
		}

		if (trt > 0) $("#overlay .tray").css("right", (130 - trt) + "px");

		$("#panels").append(Wcag.node);
		Wcag.node.find(".wcag-btn").on("click", Wcag.toggle);

		setTimeout(function() {
			Wcag.node.find(".wcag-btn").attr("title", TPL.lng("tips.wcagtitle", "Informacje dla niepełnosprawnych WCAG 2.1"));		
			Wcag.node.find(".blind-btn").attr("title", TPL.lng("tips.blindtitle", "Wersja dla niewidomych"));
		}, 1000);

		Wcag.node.find(".blind-btn").on("click", function() {
			document.location = "/text";
			//window.open("/text", "_blank");
		});

		$(Comments).on("shown", function() {
			Wcag.node.find(".wcag-btn").css("right", "360px");
		});

		$(Comments).on("hide", function() {
			Wcag.node.find(".wcag-btn").css("right", "");
		});

		if (window.PROJECT.settings['accessibility/docoff'] == undefined || window.PROJECT.settings['accessibility/docoff'] != "1") {
			if (window.PROJECT.settings['accessibility/docurl'] != undefined && window.PROJECT.settings['accessibility/docurl'] != "") {
				var durl = window.PROJECT.settings['accessibility/docurl'];
				if (durl.substr(0, 1) == '@') {
					Wcag.button = $("<a href='javascript:void(null);' onclick='player.go(" + durl.substr(1) + ")' class='deklaracjabutton' data-speak='PLAYER.DEKLARACJA' data-speakgroup='TIPS' title='" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "'>" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "</a>");					
				} else {
					Wcag.button = $("<a href='" + window.PROJECT.settings['accessibility/docurl'] + "' target='_blank' class='deklaracjabutton' data-speak='PLAYER.DEKLARACJA' data-speakgroup='TIPS' title='" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "'>" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "</a>");					
				}
				if (!Screen.xs()) $("#overlay .tray").prepend(Wcag.button);

				/*
				Tab.add("bottom", {
					"focus": function(m) {
						//console.log("focus szybka prezentacja");
						$(".deklaracjabutton").addClass("focused");
						$(".deklaracjabutton").focus();
					},

					"blur": function(m) {
						//console.log("blur szybka prezentacja");
						$(".deklaracjabutton").removeClass("focused");
					}
				}, {});
				*/
				Tab.add("bottom", Tab.simpleTab($(".deklaracjabutton"), 20), {});
			} else {
				Wcag.button = $("<a href='javascript:void(null);' class='deklaracjabutton disabled' data-speak='PLAYER.DEKLARACJA' data-speakgroup='TIPS' title='" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "'>" + TPL.lng("deklaracja_button", "Deklaracja dostępności") + "</a>");
				if (!Screen.xs()) $("#overlay .tray").prepend(Wcag.button);
			}			
		}

		if (!hidewcag) Tab.add("wcag", Tab.simpleTab($(".wcag-btn"), 26), {});			
		if (!hideblind) Tab.add("wcag", Tab.simpleTab($(".blind-btn"), 25), {});


	//	SpeechManager.enableSpeech("#ui", ".speaks", 1, "TOPMENU");
	},

	toggle: function() {
		Wcag.toggletext();

		if (!Wcag.isActive) {
			Wcag.isActive = true;
		} else {
			Wcag.isActive = false;
		}
	},

	preventKeys: function(evt) {
		evt.stopPropagation();
		return false;
	},

	toggletext: function() {
		if (Wcag.textVisible) Wcag.closetext();
		else Wcag.opentext();
	},

	opentext: function() {
		Wcag.textVisible = true;
		Wcag.node.find(".wcag-info").addClass("wcag-info-show");
	},

	closetext: function() {
		Wcag.textVisible = false;
		Wcag.node.find(".wcag-info").removeClass("wcag-info-show");
	},

	placeReady: function(pe) {
	},
}

PluginManager.add(Wcag);